export default "__VITE_ASSET__00641daa__"